/**
 * Case management types
 * These types match the backend schema
 */

export enum CaseStatus {
  PREPARING_FILING = 'preparing_filing',       // 准备立案材料
  FILED = 'filed',                             // 立案
  SUPPLEMENTING = 'supplementing',             // 补充材料
  MEDIATION = 'mediation',                     // 调解
  HEARING = 'hearing',                         // 开庭
  AWAITING_VERDICT = 'awaiting_verdict',       // 等待裁决书
  FIRST_INSTANCE = 'first_instance',           // 一审
  SECOND_INSTANCE = 'second_instance',         // 二审
  RETRIAL = 'retrial',                         // 再审
  ENFORCEMENT = 'enforcement',                 // 执行
  ACTIVE = 'active',                           // 进行中（兼容旧数据）
  SUSPENDED = 'suspended',                     // 已暂停
  MEDIATION_CLOSED = 'mediation_closed',       // 调解结案
  VERDICT_CLOSED = 'verdict_closed',           // 裁决结案
  CLOSED = 'closed',                           // 已结案
}

export interface CaseDetail {
  case_reason?: string;
  case_level?: string;
  court_name?: string;
  court_contact?: string;
  case_summary?: string;
  fee_situation?: string;
  secondary_reason?: string;
  notes?: string;
}

export interface Case {
  id: number;
  case_number: string;
  case_name: string;
  case_type: string;
  case_stage?: string;
  case_status: CaseStatus;
  accept_date?: string;
  court_date?: string;
  verdict_date?: string;
  responsible_lawyer_id: number;
  responsible_lawyer_name?: string;
  assistant_lawyer_id?: number;
  assistant_lawyer_name?: string;
  creator_name?: string;
  created_by: number;
  created_at: string;
  updated_at?: string;
  details?: CaseDetail;
}

export interface CaseStatistics {
  total_cases: number;
  active_cases: number;
  closed_cases: number;
  suspended_cases: number;
  my_cases: number;
  as_responsible: number;
  as_assistant: number;
  this_month_new: number;  // 全局本月新增
  my_this_month_new: number;  // 我的本月新增
}
